$(document).ready(function () {
  $(".vehicle-images .arrow.left-arrow").on("click", clickLeftArrow);
  $(".vehicle-images .arrow.right-arrow").on("click", clickRightArrow);
  $(".vehicle-images .vehicle-image").on("click", clickImage);
  $(".vehicle-images .vehicle-images-container-close button").on(
    "click",
    clickClose
  );
});

function getMax(selector) {
  return $(selector).children().length;
}

function getIndex(selector) {
  var attr = $(selector).attr("data-index");
  var value = 0;
  if (typeof attr !== "undefined" && attr !== false && !isNaN(parseInt(attr))) {
    value = parseInt(attr);
  }
  return value;
}

function setIndex(selector, value) {
  $(selector).attr("data-index", value);
}

function setWrapper(noAnimation = false) {
  var selector = ".vehicle-images .vehicle-images-grid";
  var index = getIndex(selector);

  if (noAnimation) {
    $(selector).addClass("no-animation");
  }

  var margin = 0;
  if (index > 0) {
    $(selector)
      .children()
      .slice(0, index)
      .each(function () {
        margin += $(this).outerWidth();
      });
  }
  $(selector).css("margin-left", margin * -1 + "px");
  $(".vehicle-images-wrapper").css(
    "width",
    $(selector).children().eq(index).outerWidth()
  );
  $(".vehicle-images-wrapper")
    .css("height", "auto")
    .css("height", $(selector).children().eq(index).outerHeight());

  $(selector).children().removeClass("selected").eq(index).addClass("selected");
  $(".vehicle-image-wrapper.selected")
    .css("width", $(".vehicle-images-wrapper").outerWidth() + "px")
    .css("height", $(".vehicle-images-wrapper").outerHeight() + "px");

  if (noAnimation) {
    $(selector).removeClass("no-animation");
  }
}

function resizeImages() {
  var images = $(
    ".vehicle-images-container .vehicle-image-wrapper .vehicle-image img"
  );
  var maxTextHeight = 0;
  $(
    ".vehicle-images-container .vehicle-image-wrapper .vehicle-image-label"
  ).each(function () {
    maxTextHeight = Math.max($(this).outerHeight(), maxTextHeight);
  });

  var maxHeight = window.innerHeight - (128 + maxTextHeight);
  var maxWidth = window.innerWidth - 100;
  images.css("max-height", maxHeight + "px").css("max-width", maxWidth + "px");

  setWrapper();
}

function clickLeftArrow() {
  var selector = ".vehicle-images .vehicle-images-grid";
  var index = (getIndex(selector) + getMax(selector) - 1) % getMax(selector);
  setIndex(selector, index);
  setWrapper();
}

function clickRightArrow() {
  var selector = ".vehicle-images .vehicle-images-grid";
  var index = (getIndex(selector) + getMax(selector) + 1) % getMax(selector);
  setIndex(selector, index);
  setWrapper();
}

function clickImage() {
  var selector = $(this).closest(".vehicle-images-container");
  if (!$(selector).hasClass("detached")) {
    detachImagesContainer();
  }
}

function clickClose() {
  var selector = $(this).closest(".vehicle-images-container");
  if ($(selector).hasClass("detached")) {
    attachImagesContainer(null);
  }
}

function detachImagesContainer() {
  var container = $(".vehicle-images-container");
  var height = container.outerHeight();

  $(window).on("resize.monster", resizeImages);
  resizeImages();

  $("<div></div>")
    .addClass("vehicle-images-container-placeholder")
    .css("height", height + "px")
    .insertBefore(container);
  container.addClass("detached").insertAfter("custom-pagination");
  container.on("click", attachImagesContainer);

  $(".vehicle-image-wrapper").css("width", "").css("height", "");
  setWrapper(true);
}

function attachImagesContainer(e) {
  if (e === null || e.target === this) {
    var container = $(".vehicle-images-container");
    var placeholder = $(".vehicle-images-container-placeholder");
    var images = container.find(".vehicle-image-wrapper .vehicle-image img");

    $(window).off("resize.monster");

    images.css("max-height", "").css("max-width", "");
    container.removeClass("detached").insertBefore(placeholder);
    container.off("click", attachImagesContainer);
    placeholder.remove();

    $(".vehicle-image-wrapper").css("width", "").css("height", "");
    setWrapper(true);
  }
}
